import { useLanguage } from '../context/LanguageContext';
import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import { getSmartTranslation, getUISafeTranslation } from '../utils/translationUtils';

const translations = {
  en: enTranslations,
  fr: frTranslations,
};

export const useTranslation = () => {
  const { language } = useLanguage();

  const t = (key, params = {}, options = {}) => {
    const { maxLength, useSmart = false } = options;
    
    // Use smart translations for UI elements
    if (useSmart || key.startsWith('ui.')) {
      const smartKey = key.replace('ui.', '');
      const translation = getSmartTranslation(language, smartKey);
      return maxLength ? getUISafeTranslation(language, smartKey, maxLength) : translation;
    }
    
    const keys = key.split('.');
    let translation = translations[language];
    
    // Navigate through nested keys
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        // Fallback to English if translation not found
        translation = translations.en;
        for (const fallbackKey of keys) {
          if (translation && translation[fallbackKey]) {
            translation = translation[fallbackKey];
          } else {
            return key; // Return the key if no translation found
          }
        }
        break;
      }
    }

    // If translation is a string, apply parameters
    if (typeof translation === 'string') {
      const result = translation.replace(/\{(\w+)\}/g, (match, param) => params[param] || match);
      return maxLength ? getUISafeTranslation(language, result, maxLength) : result;
    }

    return translation || key;
  };

  // UI-safe translation function
  const tUI = (key, maxLength = 20) => {
    return getUISafeTranslation(language, key, maxLength);
  };

  return { t, tUI, language };
};